import { Map } from 'immutable';

import BaseStore from './BaseStore';
import { ActionTypes, BreakPoints } from '../constants/AppConstants';


export class DimensionsStore extends BaseStore {

    getWindowSize () {
        return new Map({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }

    getInitialState () {
        return this.getWindowSize();
    }

    handleResize () {
        this.setState(this.getWindowSize());
    }

    getActionHandlers () {
        return {
            [ActionTypes.WINDOW_RESIZED]: this.handleResize
        };
    }

    isMobileWidth () {
        return this.state.get('width') < BreakPoints.TABLET_PORTRAIT_WIDTH;
    }

    isTabletWidth () {
        return this.state.get('width') >= BreakPoints.TABLET_PORTRAIT_WIDTH && this.state.get('width') < BreakPoints.DESKTOP_WIDTH;
    }

    isDesktopWidth () {
        return this.state.get('width') >= BreakPoints.DESKTOP_WIDTH;
    }

    isDesktopLWidth () {
        return this.state.get('width') >= BreakPoints.DESKTOP_WIDTH_L;
    }

    isDesktopXLWidth () {
        return this.state.get('width') >= BreakPoints.DESKTOP_WIDTH_XL;
    }
}

const instance = new DimensionsStore();

export default instance;



// WEBPACK FOOTER //
// ./src/stores/DimensionsStore.js